// https://gist.github.com/necolas/1c494e44e23eb7f8c5864a2fac66299a#gistcomment-3110594
import { isHoverEnabled } from './HoverState';
import React from 'react';
/** TODO: This implementation is slightly flawed. It does not handle
 * the case when an element is inserted into the DOM at the
 * current position of the cursor.
 *
 * In this scenario, the hoverstate will not trigger until the
 * cursor leaves the element and is subsequently moved back in.
 *
 * Should look into an implementation that supports this scenario as
 * it is often encountered when browsing content thumbnails with
 * buttons overlaid */
const Hoverable = (props) => {
    const { onHoverIn, onHoverOut, children } = props;
    const [isHovered, setHovered] = React.useState(false);
    const [showHover, setShowHover] = React.useState(true);
    function handleMouseEnter() {
        if (isHoverEnabled() && !isHovered) {
            if (onHoverIn)
                onHoverIn();
            setHovered(true);
        }
    }
    function handleMouseLeave() {
        if (isHovered) {
            if (onHoverOut)
                onHoverOut();
            setHovered(false);
        }
    }
    // [TODO]
    //  - onPressIn and onPressOut may be available in later versions of RN/RNWeb
    //  - Commentout for now
    // function handleGrant() {
    //   setShowHover(false);
    // }
    // function handleRelease() {}
    const child = typeof children === 'function'
        ? children(showHover && isHovered)
        : children;
    return React.cloneElement(React.Children.only(child), {
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        // prevent hover showing while responder
        onResponderGrant: () => setShowHover(false),
        onResponderRelease: () => setShowHover(true),
        // if child is Touchable
        // [TODO]: May need to upgrade RN/RNWeb
        // onPressIn: handleGrant,
        // onPressOut: handleRelease,
    });
};
Hoverable.displayName = 'Hoverable';
export default Hoverable;
//# sourceMappingURL=Hoverable.js.map